module.exports = __webpack_public_path__ + "static/media/ENGLong3w427@2x.9bbd7d71.jpg";